import { cn } from "@/lib/utils";

export function Eyebrow({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <p
      className={cn(
        "text-[11px] uppercase tracking-[0.18em] text-primary font-semibold",
        className,
      )}
    >
      {children}
    </p>
  );
}
